import { atlasBookOpen, atlasUpdate, atlasVideo } from "@resource/atlas/icons";
import { isProduction } from "utils/environment";

type LinkItems = {
  getStarted: LinkItem;
  takeTour: LinkItem;
  watchVideo: LinkItem;
};

export type LinkItem = {
  href: string;
  icon: string;
  label: string;
  isLoom?: boolean;
};

export default {
  getStarted: {
    href: "https://support.guide.co/en/articles/6988905-guide-dpp-candidate-surveys",
    icon: atlasBookOpen,
    label: "Get Started",
  },
  takeTour: {
    href: isProduction
      ? "https://app.guide.co/surveys?product_tour_id=413304"
      : "https://app.guide.co/surveys?product_tour_id=415528",
    icon: atlasUpdate,
    label: "Take a tour",
  },
  watchVideo: {
    href: "https://www.loom.com/share/ea9457f116994ccb88b3388102f10e7a",
    icon: atlasVideo,
    label: "Watch a video",
  },
} as LinkItems;
